import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';

const NotificationBell = () => {
  const { messages, markMessageAsRead } = useData();
  const { currentUser } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  
  const getCurrentUserId = () => {
    return currentUser?.id || currentUser?.uid;
  };
  
  const currentUserId = getCurrentUserId();
  
  // Get unread messages for current user
  const unreadMessages = messages.filter(message => 
    message.receiverId === currentUserId && !message.read
  );
  
  // Get recent messages (last 5)
  const recentMessages = messages
    .filter(message => message.receiverId === currentUserId)
    .slice(0, 5);
  
  const handleMarkAsRead = async (messageId) => {
    try {
      await markMessageAsRead(messageId);
      setShowDropdown(false);
    } catch (error) {
      console.error('Error marking message as read:', error);
    }
  };
  
  const handleMarkAllAsRead = async () => {
    try {
      for (const message of unreadMessages) {
        await markMessageAsRead(message.id);
      }
    } catch (error) {
      console.error('Error marking all messages as read:', error);
    }
  };

  // Don't show bell if no current user
  if (!currentUserId) return null;

  return (
    <div className="notification-bell">
      <button 
        className="notification-button"
        onClick={() => setShowDropdown(!showDropdown)}
        title={`${unreadMessages.length} unread messages`}
      >
        <i className="fas fa-bell"></i>
        {unreadMessages.length > 0 && (
          <span className="notification-badge">{unreadMessages.length}</span>
        )}
      </button>
      
      {showDropdown && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h4>Messages ({unreadMessages.length} unread)</h4>
            {unreadMessages.length > 0 && (
              <button 
                className="mark-all-read"
                onClick={handleMarkAllAsRead}
              >
                Mark all as read
              </button>
            )}
          </div>
          
          <div className="notification-list">
            {recentMessages.length > 0 ? (
              recentMessages.map(message => (
                <div 
                  key={message.id} 
                  className={`notification-item ${!message.read ? 'unread' : ''}`}
                  onClick={() => handleMarkAsRead(message.id)}
                >
                  <div className="notification-content">
                    <h5>{message.subject}</h5>
                    <p>From: {message.senderName}</p>
                    <span className="notification-time">
                      {new Date(message.timestamp).toLocaleDateString()}
                    </span>
                  </div>
                  {!message.read && <div className="unread-dot"></div>}
                </div>
              ))
            ) : (
              <div className="no-notifications">
                <i className="fas fa-inbox"></i>
                <p>No messages yet</p>
              </div>
            )}
          </div>
          
          <div className="notification-footer">
            <button 
              className="view-all-btn"
              onClick={() => setShowDropdown(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
